import AdministrativeUnit2Level from './administrative-unit-2level';
import { SelectUnit } from './select-unit';

const CustomAdministrativeUnit = {
    // /**Root Version 
    //  * @deprecated
    // */
    // Root: AdministrativeUnit,
    // /**
    //  * Version 2
    //  * Not stable
    //  * @deprecated
    //  */
    // V2: AdministrativeUnitV2,

    /**
     * AdministratorUnit 2 level (Province, Ward)
     */
    Level2: AdministrativeUnit2Level,

    SelectUnit: SelectUnit,
    name: 'Custom select administrative unit',
};

export type * from './select-unit';
export type * from './administrative-unit-2level';
export default CustomAdministrativeUnit;
